// @ts-strict-ignore
/**
 * @owner @Appboy/clip
 */

import React from "react";

import { dangerToast, successToast } from "@lib/brazeToaster";
import type { I18nT } from "@lib/dashboardI18n";

import type { ElevatedAccessToasts } from "./types";

export const elevatedAccessToasts: { current: ElevatedAccessToasts } = {
  current: {
    popupBlockerDetectedToast: () => "",
    verificationFailureToast: () => "",
    verificationSuccessToast: () => "",
  },
};

export const setElevatedAccessToasts = (t: I18nT<"elevated-access">) => {
  elevatedAccessToasts.current = {
    popupBlockerDetectedToast: () => {
      return dangerToast(
        <>
          {t(
            "popup-blocker-detected",
            "Popup blocker detected. Please disable it to proceed with identity verification."
          )}
        </>
      );
    },
    verificationSuccessToast: () => {
      return successToast(<>{t("verification-successful", "Identity verification successful.")}</>);
    },
    verificationFailureToast: () => {
      const content = (
        <div>
          {t("verification-failed", "Validation failed.")}{" "}
          {t("refresh-try-again", "Please refresh the page and try again.")}
        </div>
      );
      return dangerToast(content);
    },
  };
};
